import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { Button, Menu, MenuItem } from "@mui/material";
import ApiCall from "../../utils/Api";
import Web3 from "web3";
import axios from "axios";
import { toast } from "react-toastify";
import bigInt from "big-integer";
import Swal from "sweetalert2";
import contractABI from "../../utils/contractABI";
import EditIcon from '@mui/icons-material/Edit';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';

import {convertDateFormat,extractTimeFromTimestamp} from "../../utils/services";


// const [changeC

export default function DataConsumerDetailsTable({
  setBackDropState,
  BackDropState,
  instrument,
  market,
  institutionName,
}) {
  console.log('🚀 ~ DataConsumerDetailsTable rendering with props:', {
    instrument,
    market,
    institutionName
  });
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  console.log("🚀 ~ contractAddress:", contractAddress)
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
  const [isconnected, setisconnected] = useState(false);
  const [rows, setRows] = useState([]);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [updateCount, setupdateCount] = useState(0);
  const [UnitStatus, setUnitStatus] = useState("");

  useEffect(() => {
    const getAllProviderRequest = async () => {
      try {
        console.log('🚀 ~ Making API call with params:', { market, instrument, institutionName });
        let datafile = await ApiCall.SECURE_API.get(
          `/provider/getDataUnitsSoldByProvider?market=${market}&isnstrument=${instrument}&institutionName=${institutionName}&period=`
        );
        console.log(
          "🚀 ~ DataConsumerDetailsTable ~ API response:",
          datafile?.data?.data
        );
        let newData = datafile?.data?.data;
        console.log("🚀 ~ DataConsumerDetailsTable ~ newData:", newData);
        console.log("🚀 ~ DataConsumerDetailsTable ~ newData length:", newData?.length);
        setRows(newData);
      } catch (error) {
        console.log("🚀 ~ useEffect ~ error:", error);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.message);
        }
      }
    };
    getAllProviderRequest();
  }, [market, instrument, institutionName,updateCount]);
  // const navigate = useNavigate();
  useEffect(() => {
    const getWalletAddress = async () => {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        const data = await ApiCall.SECURE_API.get(
          "/provider/GetWalletAddresses"
        );
        console.log("🚀 ~ formattedOptions ~ data.data.data:", data.data.data);
        let WalletsIds = data.data.data;
        let options = {};
        let connectedWallet = "";
        console.log(
          "🚀 ~ getWalletAddress ~ connectedWallet:",
          connectedWallet
        );

        console.log("🚀 ~ getWalletAddress ~ accounts:", accounts);
        for (let index = 0; index < WalletsIds.length; index++) {
          for (let index2 = 0; index2 < accounts.length; index2++) {
            console.log(
              "================================>>>>Checking account",
              WalletsIds[index],
              accounts[index2]
            );

            if (
              WalletsIds[index].toLowerCase() === accounts[index2].toLowerCase()
            ) {
              console.log("====================================>>>>>Check");

              connectedWallet = WalletsIds[index];
            }
            // console.log("🚀 ~ getWalletAddress ~ WalletsIds[index]:", WalletsIds[index])
            // console.log("🚀 ~ getWalletAddress ~ accounts[index2]:", accounts[index2])
            if (connectedWallet) {
              options[connectedWallet] = connectedWallet.toLowerCase();
            }
          }
        }
        setWalletAddresses(options);
        console.log("🚀 ~ getWalletAddress ~ options:", options);
        console.log("🚀 ~ getWalletAddress ~ options:", {
          apples: "Apples",
          bananas: "Bananas",
          grapes: "Grapes",
          oranges: "Oranges",
        });

        // const formattedOptions = data.data.data.reduce((options, [value, label]) => {
        //   options[value] = label;
        //   return options;
        // }, {});
      } catch (error) {
        console.log("🚀 ~ getWalletAddress ~ error:", error);
        // if (error?.response?.data?.message) {
        //   toast.error(error.response.data.message);
        // } else {
        //   toast.error(error.message);
        // }
      }
    };
    getWalletAddress();
  }, []);
  const [showPopup, setShowPopup] = useState(false);
  const [results, setResults] = useState([]);
  const [item, setItem] = useState({});
  const [resultq, setResultq] = useState("");
  const [prov_address, setprov_Address] = useState("");
  const role=localStorage.getItem("role")

  // useEffect(() => {
  //   // console.log(props.contract, props.web3);

  //   getAllDataUnits();
  // }, []);

  // const axios = require('axios');








  async function buyDataUnit(dataUnit, walletId) {
    console.log("🚀 ~ buyDataUnit ~ walletId:", walletId);
    console.log(
      "🚀 ~ buyDataUnit ~ JSON.parse(dataUnit.dataunitId):",
      dataUnit
    );
    console.log("🚀 ~ buyDataUnit ~ dataUnit:", dataUnit);
    try {
      // const accounts = await web3.eth.getAccounts();
      // console.log("🚀 ~ buyDataUnit ~ accounts:", accounts)
      const providerAddress = walletId; // Assuming the user's address is the provider's address
      const price = dataUnit.price;
      console.log("====================================pppppp", price);

      const etherAmount = web3.utils.fromWei(price, "ether");
      console.log(
        "===============================================>>>",
        etherAmount
      );
      setBackDropState(true);
      console.log("🚀 ~ buyDataUnit ~ price:", price)
      console.log("🚀 ~ buyDataUnit ~ dataUnit.dataunitId:", dataUnit.dataunitId)
      console.log("🚀 ~ buyDataUnit ~ providerAddress:", providerAddress)
      console.log("🚀 ~ buyDataUnit ~ contract:", contract);
      const transaction = await contract.methods
        .buyDataUnit(dataUnit.dataunitId, { value: price })
        .send({
          from: providerAddress,
          value: price, // Include the price value in the transaction
        });
      console.log("transaction.transactionHash", transaction.transactionHash);
      setBackDropState(false);
      if (transaction.transactionHash) {
        console.log("🚀 ~ buyDataUnit ~ dataUnit:", dataUnit)
        console.log("🚀 ~ buyDataUnit ~ transaction.transactionHash:", transaction.transactionHash)
        const splittransaction = await contract.methods
        .splitAndTransferToken(transaction.from,dataUnit.providerWalletAddress, contractAddress, price);
        console.log("🚀 ~ buyDataUnit ~ splittransaction:", splittransaction)

        const data = await ApiCall.SECURE_API.post("/buyer/buyDataUnit", {
          dataUnitId: dataUnit._id,
          transactionHash: transaction.transactionHash,
          WalletAddress: providerAddress,
        });
        setupdateCount(updateCount+1)
        toast.success("You Successfully Buyed Data Unit");

        console.log("🚀 ~ buyDataUnit ~ data:", data);
      }
      console.log(
        "🚀 ~ file: Dataunitdetail.js:120 ~ buyDataUnit ~ transaction:",
        transaction
      );
      console.log("Data unit bought successfully");
      setResultq("Your transaction was successful.");
      setShowPopup(true);
    } catch (error) {
      setBackDropState(false);
      console.log("Error buying data unit:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
      setResultq("Error buying data unit. Please try again.");
      setShowPopup(true);
    }
  }
  const [WalletAddresses, setWalletAddresses] = useState();
  useEffect(() => {
    const getWalletAddress = async () => {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        const data = await ApiCall.SECURE_API.get(
          "/consumer/GetWalletAddresses"
        );
        console.log("🚀 ~ formattedOptions ~ data.data.data:", data.data.data);
        let WalletsIds = data.data.data;
        let options = {};
        let connectedWallet = "";
        console.log(
          "🚀 ~ getWalletAddress ~ connectedWallet:",
          connectedWallet
        );

        console.log("🚀 ~ getWalletAddress ~ accounts:", accounts);
        for (let index = 0; index < WalletsIds.length; index++) {
          for (let index2 = 0; index2 < accounts.length; index2++) {
            console.log(
              "================================>>>>Checking account",
              WalletsIds[index],
              accounts[index2]
            );

            if (
              WalletsIds[index].toLowerCase() === accounts[index2].toLowerCase()
            ) {
              console.log("====================================>>>>>Check");

              connectedWallet = WalletsIds[index];
            }
            // console.log("🚀 ~ getWalletAddress ~ WalletsIds[index]:", WalletsIds[index])
            // console.log("🚀 ~ getWalletAddress ~ accounts[index2]:", accounts[index2])
            if (connectedWallet) {
              options[connectedWallet] = connectedWallet.toLowerCase();
            }
          }
        }
        setWalletAddresses(options);
        console.log("🚀 ~ getWalletAddress ~ options:", options);
        console.log("🚀 ~ getWalletAddress ~ options:", {
          apples: "Apples",
          bananas: "Bananas",
          grapes: "Grapes",
          oranges: "Oranges",
        });

        // const formattedOptions = data.data.data.reduce((options, [value, label]) => {
        //   options[value] = label;
        //   return options;
        // }, {});
      } catch (error) {
        console.log("🚀 ~ getWalletAddress ~ error:", error);
        // if (error?.response?.data?.message) {
        //   toast.error(error.response.data.message);
        // } else {
        //   toast.error(error.message);
        // }
      }
    };
    getWalletAddress();
  }, []);
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // const handleGoBack = () => {
  //   navigate("/main");
  // };
  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        // if (error?.response?.data?.message) {
        //            toast.error(error.response.data.message);
        //          } else {
        //            toast.error(error.message);
        //          }
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3();
  }, []);
  useEffect(() => {
    const initContract = async () => {
      try {
        
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);
 const onSubmitBuyDataUnit=(row)=>{
  if(row.isAlreadyPurchased){
    Swal.fire({
      title: "Are you sure?",
      text: "You have already purchased this data unit.Do you want to purchase it again?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, But it again"
    }).then((result) => {
      if (result.isConfirmed) {
      Swal.fire({
        title: "Select Wallet Address",
        input: "select",
        inputOptions: WalletAddresses,
        inputPlaceholder: "Select Wallet Address",
        showCancelButton: true,
        inputValidator: (value, index) => {
       
          buyDataUnit(row, value);

          // return new Promise((resolve) => {
          //   if (value === "oranges") {
          //     resolve();
          //   } else {
          //     resolve("You need to select oranges :)");
          //   }
          // });
        },
      });
    }
    })
  }else{
    Swal.fire({
      title: "Select Wallet Address",
      input: "select",
      inputOptions: WalletAddresses,
      inputPlaceholder: "Select Wallet Address",
      showCancelButton: true,
      inputValidator: (value, index) => {
     
        buyDataUnit(row, value);

        // return new Promise((resolve) => {
        //   if (value === "oranges") {
        //     resolve();
        //   } else {
        //     resolve("You need to select oranges :)");
        //   }
        // });
      },
    });
  }
  }
  const [ethPrice, setEthPrice] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiCall.Api.get('/thirdPartyApi/getCryptoData');
        const ethereumData = response.data.data['1027'];
        // Extract the USD price from the API response
        const usdPrice = ethereumData.quote.USD.price;
        console.log("🚀 ~ fetchData ~ usdPrice:", usdPrice)
        // Update the state with the USD price

        
        setEthPrice(usdPrice);
        // const exchangeRate = ethereumData.quote.USD.price;
        // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
        // setUsdAmount(convertedUsdAmount.toFixed(2));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);
  const getPriceInUsd=(value)=>{
const exchangeRate = ethPrice;
        const convertedUsdAmount = parseFloat(value) * exchangeRate;
       return convertedUsdAmount.toFixed(6)
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }
  const DropDown=(row)=>{
    console.log(row)
    console.log("🚀 ~ DropDown ~ row.available:", row.available)

    return(
      <>
      <span  onClick={(e) => {
                    handleClick(e);
                  }} style={{color:"green",cursor:"pointer"}} >{row.available?<span>Available</span>:<span style={{color:"red"}}>Unavailable</span>}</span>
       
        <Menu id="simple-menu" anchorEl={anchorEl} open={anchorEl} onClose={handleClose}>
                  <MenuItem
                    onClick={() => {
                      // setOpen(true)
                      // Navigate(`/admin-panel/Booking/Room_Detail/${"Edit"}/${deleteState}`)
                      updateStatusFunction(true)
                      handleClose();
                    }}
                  >
                    <span style={{ display: 'flex', width: '100%', padding: 5 }}>
                      {/* <EditIcon onClick={() => { }} style={{ marginRight: 5 }} /> */}
                      <span>Available</span>
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      // setOpen(true)
                      // Navigate(`/admin-panel/Booking/Room_Detail/${"Edit"}/${deleteState}`)
                      updateStatusFunction(false)

                      handleClose();
                    }}
                  >
                    <span style={{ display: 'flex', width: '100%', padding: 5 }}>
                      {/* <EditIcon onClick={() => { }} style={{ marginRight: 5 }} /> */}
                      <span>Unavailable</span>
                    </span>
                  </MenuItem>
                
                </Menu>
      </>
    )
  }
  const updateStatusFunction = async (status) => {
    console.log("🚀 ~ updateStatusFunction ~ status:", status)
    console.log("🚀 ~ updateStatusFunction ~ UnitStatus:", UnitStatus)
    try {
      const response = await ApiCall.SECURE_API.post('/admin/updateDataunitAvailability',{
        "dataunitId": UnitStatus,
        "available": status
    
    });
    if(response.data.success==true){
toast.success(response.data.message);
setupdateCount(updateCount+1)

    }
      // const exchangeRate = ethereumData.quote.USD.price;
      // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
      // setUsdAmount(convertedUsdAmount.toFixed(2));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
const handleRowClick=(row,id,index) => {
  console.log("🚀 ~ handleRowClick ~ row:", row)
  console.log("🚀 ~ handleRowClick ~ id:", id)
  console.log("🚀 ~ handleRowClick ~ index:", index)
  console.log("🚀 ~ handleClick ~ row:", row._id)
  setUnitStatus(row._id)

}
  console.log("Boyah========================", rows);
  function formatEtherFromWei(weiValue, decimalPlaces) {
    // Convert wei to ether using Web3.js utility function
    const etherValue = web3.utils.fromWei(weiValue, "ether");

    // Limit the ether value to a specified number of decimal places
    const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);

    // Return the formatted ether value with "ETH" appended
    return formattedEther + " ETH";
}
  return (
    <TableContainer style={{ borderRadius: 9 }} component={Paper}>
      <Table sx={{ minWidth: 750 }} aria-label="simple table">
        <TableHead style={{ backgroundColor: "Black" }}>
          <TableRow>
            <TableCell align="center" style={{ color: "white" }}>
              Created At
            </TableCell>
          
            <TableCell align="center" style={{ color: "white" }}>
            Units Sold
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
            Market
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
            Instrument
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
            Name
            </TableCell>
                        <TableCell align="center" style={{ color: "white" }}>
              Price in ETH & USD
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
            Gross Sales
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
            Net Sales
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
           Link
            </TableCell>
            {/* <TableCell align="center" style={{ color: "white" }}></TableCell> */}
            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {console.log('🚀 ~ DataConsumerDetailsTable ~ Rendering table with rows:', rows, 'Length:', rows?.length)}
          {rows?.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <div style={{ padding: '20px', color: 'gray' }}>
                  No data available. Please select filters above to view transactions.
                </div>
              </TableCell>
            </TableRow>
          )}
          {rows?.map((row, index) => (
            <TableRow
              key={row._id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              onClick={()=>{
                
                handleRowClick(row, row._id,index)
              
              }}
            >
              <TableCell align="center">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    
                    <span style={{ fontWeight: 600 }}>
                      {" "}
                      {convertDateFormat(row.createdAt)}
                    </span>
                    <span style={{ color: "gray" }}>
                      {" "}
                      {extractTimeFromTimestamp(row.createdAt)}
                    </span>
                  </div>
                </div>
              </TableCell>
          
              <TableCell align="center">{row.totalUnitsSold}</TableCell>
              <TableCell align="center">{row.market}</TableCell>
              <TableCell align="center">{row.instrument}</TableCell>
              <TableCell align="center">{row.name}</TableCell>

              <TableCell >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {" "}
                      {formatEtherFromWei(row?.price, 6)}
                    </span>
                    <span style={{ color: "gray" }}>
                      {" "}
                      {getPriceInUsd(web3?.utils?.fromWei(row?.price, "ether"))} USD
                    </span>
                  </div>
                </div>
              </TableCell>
              <TableCell >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {" "}
                      {formatEtherFromWei(row?.totalGrossAmount,6)}
                    </span>
                    <span style={{ color: "gray" }}>
                      {" "}
                      {getPriceInUsd(web3?.utils?.fromWei(row?.totalGrossAmount, "ether"))} USD
                    </span>
                  </div>
                </div>
              </TableCell>
              {/* <TableCell align="center">{row.available?<span style={{color:"green"}} >Available</span>:<span style={{color:"red"}}>Not Available</span>}</TableCell> */}
              <TableCell >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {" "}
                      {formatEtherFromWei(row?.totalProviderSplitAmount,6)}
                    </span>
                    <span style={{ color: "gray" }}>
                      {" "}
                      {getPriceInUsd(web3?.utils?.fromWei(row?.totalProviderSplitAmount
, "ether"))} USD
                    </span>   
                  </div>
                </div>
              </TableCell>

              <TableCell align="center"><Link to={`DataConsumerDetailsSecound/${row._id}`}>View Details</Link></TableCell>

            
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
